import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

interface Toast {
    title?: string;
    text: string;
    icon?: "success" | "error" | "warning" | "info";
    toast?: boolean;
    position?: "bottom";
    timer?: number;
    timerProgressBar?: boolean;
    showConfirmButton?: boolean;
}

const defaultOptions: Toast = {
    text: "",
    icon: "success",
    toast: true,
    position: "bottom",
    timer: 3000,
    timerProgressBar: true,
    showConfirmButton: false,
};

export default async function useToast(options: Toast) {
    if (!options.text) {
        throw new Error("Toast text is required.");
    }

    await Swal.fire({
        ...defaultOptions,
        ...options,
    });
}
